module.exports = __webpack_public_path__ + "img/6-3.932e7473.png";